export default __webpack_public_path__ + "alberta-person-chip.46d8f38fe338e28571ba.svg";